// ----------------------------------------------------------------------

const account = {
  displayName: 'Clayvant Inc.',
  displayText: 'Manage account',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
